import styled from 'styled-components';

import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

import { colors } from 'theme/colors';

export const ControlsNavIcon = styled(ShieldOutlinedIcon)<{ $active?: boolean }>`
  width: 18px;
  height: 18px;
  color: ${({ $active }) => ($active ? colors.common.white : colors.ui.border.light)};
`;

export const HazardsNavIcon = styled(WarningAmberOutlinedIcon)<{ $active?: boolean }>`
  width: 18px;
  height: 18px;
  color: ${({ $active }) => ($active ? colors.common.white : colors.ui.border.light)};
`;
